<div
  class="grid-container"
  data-id="grid-container"
>
  @if (loading) {
    <div class="admin-load"></div>
  } @else {
    @for (grid of grids; track grid.id) {
      <div
        class="base-widget"
        [ngStyle]="getStyles(grid?.settings)"
      >
        <ndc-dynamic
          [ndcDynamicComponent]="grid.component"
          [ndcDynamicInputs]="{
            title: grid?.title || '',
            subTitle: grid?.params?.subTitle || '',
            icon: grid?.params?.icon || '',
            params: grid?.params || null,
          }"
        ></ndc-dynamic>
      </div>
    }
  }
</div>
